module.exports = __webpack_public_path__ + "static/media/29BDOS20.458a8322.jpg";